<template>
    <div v-if="isTitle" class="menu_couriers__list_name_section">
        {{ titleList }}
    </div>
    <menu_couriers_item
        v-for="item in listCouriers"
        :key="'menu_couriers_item_'+item.id"
        :courierItem="item"
    />
</template>

<script>

import menu_couriers_item from "./MenuCouriersItem.vue";

export default {
    name: "menu_couriers_list",
    props: {
        titleList: {
            type: String,
            required: true,
        },
        listCouriers: {
            type: Array,
            required: true,
        },
    },
    emits: [],
    components: {
        menu_couriers_item
    },
    data() {
        return {}
    },
    computed:{
        isTitle(){
            if(this.titleList !== '') {
                return true;
            }
            return false;
        }
    }
}
</script>
